export default "__VITE_ASSET__CiFSbjy8__"